import { Button } from 'antd';
import React from 'react';




const CustomButton = ({text, icon, selected, onClick, disabled}) => {
  return (
    <div onClick={onClick} className={'border h-full'} >
      <Button disabled={disabled} type='text' icon={icon} className={selected ? 'btn-selected text-white h-full font-semibold w-full rounded-none' : 'h-full font-semibold w-full rounded-none'}>
        <span className='truncate w-full'>{text}</span>
      </Button>
    </div>
  )
}

export default CustomButton;